// The initiative strip's own height (issue 1070). The bottom bar held a fixed
// 112 px whatever the strip showed — on a 720 px screen, space the board could
// use while the strip has few stones or no fight is running. The strip reports
// its natural height here; the dock sizes the bottom bar to it whenever the
// strip is what the bar holds. A module-level emitter like the board's bus:
// one strip, one dock per window.
type Listener = (px: number) => void;

let last: number | null = null;
const listeners = new Set<Listener>();

export const stripHeight = {
  /** The strip's content height in px, as it now lays out. Repeats are dropped. */
  report(px: number): void {
    const h = Math.ceil(px);
    if (!(h > 0) || h === last) return;
    last = h;
    for (const fn of listeners) fn(h);
  },
  /** Told each new height, and the last one at once if there is one. */
  subscribe(fn: Listener): () => void {
    listeners.add(fn);
    if (last !== null) fn(last);
    return () => { listeners.delete(fn); };
  },
  /** The last height reported, or null: for refitting the bar when something else about it changes. */
  current(): number | null { return last; },
  /** For tests: forget the last height. */
  reset(): void { last = null; },
};

/** The most the strip may ask of the bar, so a runaway measurement never swallows the board. */
export const STRIP_MAX = 200;

/** The bottom bar's height for a strip of `content` px under a tab header of `header` px (issue 1070); the cap grows with the text size (issue 1174). */
export function bottomBarHeight(header: number, content: number, textScale = 1): number {
  return Math.ceil(Math.max(0, header) + Math.min(STRIP_MAX * (1 + (Math.min(2, Math.max(1, textScale)) - 1) / 2), Math.max(0, content)));
}
